import Emitter from 'tiny-emitter'

const emitter = new Emitter()

// Add debug logging
const originalEmit = emitter.emit
emitter.emit = function(...args) {
  console.log('Event emitted:', args[0], 'with data:', args.slice(1))
  return originalEmit.apply(this, args)
}

export const EVENT_TYPES = {
  PERIOD_CHANGED: 'period-changed',
  AUTH_ERROR: 'auth-error'
}

export default emitter 